import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=b52b6890&scoped=true&"
import script from "./Room.vue?vue&type=script&lang=js&"
export * from "./Room.vue?vue&type=script&lang=js&"
import style0 from "./Room.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./Room.vue?vue&type=style&index=1&id=b52b6890&lang=scss&scoped=true&"
import style2 from "./Room.vue?vue&type=style&index=2&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b52b6890",
  null
  
)

export default component.exports